import Swal from 'sweetalert2'
import Inputmask from "inputmask";

import './Captcha'

// Swal Mesaj
var SwalMessageType = {
    Success: "success",
    Error: "error",
    Warning: "warning",
    Info: "info",
    Question: "question",
}
export function SwalMessage({ type = "info", text, title = "", allowOutsideClick = true, confirmButton = "Evet", cancelButton = "Hayır" }, thenFunction = function () { }) {

    let options = {
        text: text,
        icon: type,
        buttonsStyling: false,
        confirmButtonText: confirmButton,
        allowEscapeKey: true,
        // allowEnterKey: true,
        // allowOutsideClick: allowOutsideClick,
        customClass: {
            confirmButton: "btn fw-bold btn-primary",
        }
    };


    if (type == SwalMessageType.Question) {
        options.showCancelButton = true
        options.cancelButtonText = cancelButton
        options.customClass.cancelButton = "btn fw-bold btn-active-light-primary"
        options.allowOutsideClick = false
    }

    if (title != "") {
        options.title = title;
    }

    options.text = text;

    Swal.fire(options).then(function (result) {
        if (result.value) {
            thenFunction()
        }
    });
}

// Toast Mesaj
var ToastMessageType = {
    Success: 0,
    Info: 1,
    Error: 2,
    Warning: 3
}
export function ToastMessage(type, title, message) {

    // Select elements
    const container = document.getElementById('toast-stack');
    const targetElement = document.querySelector('[data-docs-toast="stack"]'); // Use CSS class or HTML attr to avoid duplicating ids

    // Remove base element markup
    // targetElement.parentNode.removeChild(targetElement);


    // Create new toast element
    const newToast = targetElement.cloneNode(true);
    container.append(newToast);

    $(newToast).find('.toast-header strong').html(title)

    $(newToast).find('.toast-body').html(message)

    switch (type) {
        case ToastMessageType.Success:
            $(newToast).find('.toast-body').addClass('text-success')
            break;

        case ToastMessageType.Info:
            $(newToast).find('.toast-body').addClass('text-info')
            break;

        case ToastMessageType.Error:
            $(newToast).find('.toast-body').addClass('text-error')
            break;

        case ToastMessageType.Warning:
            $(newToast).find('.toast-body').addClass('text-warning')
            break;

        default:
            $(newToast).find('.toast-body').addClass('text-primary')
            break;
    }

    // Create new toast instance --- more info: https://getbootstrap.com/docs/5.1/components/toasts/#getorcreateinstance
    const toast = bootstrap.Toast.getOrCreateInstance(newToast);

    // Toggle toast to show --- more info: https://getbootstrap.com/docs/5.1/components/toasts/#show
    toast.show();

}


// Inputmask
var MaskLoad = function () {

    // E-posta
    let emails = document.querySelectorAll('*[mask-type="email"]');
    // console.log(mask.email);
    emails.forEach((element) => {
        Inputmask({
            mask: mask.email,
            greedy: false,
            onBeforePaste: function (pastedValue, opts) {
                pastedValue = pastedValue.toLowerCase();
                return pastedValue.replace("mailto:", "");
            },
            definitions: {
                "*": {
                    validator: '[0-9A-Za-z!#$%&"*+/=?^_`{|}~\-]',
                    cardinality: 1,
                    casing: "lower"
                }
            }
        }).mask(element);
    })

    // Telefon
    let phones = document.querySelectorAll('*[mask-type="tel"], *[mask-type="phone"]');
    phones.forEach((element) => {


        var telInput = intlTelInput(element, {
            preferredCountries: phoneCountryList ?? ['TR', 'CA', 'EN'],
        });
        element.value = element.value.replace(telInput.s.dialCode, '')
        $(element).on("countrychange", function () {
            let dialCode = "+" + telInput.s.dialCode + element.value;
            element.setAttribute('data-value', dialCode);
            element.setAttribute('value', dialCode);
        });
        $(element).on("change", function () {
            let dialCode = "+" + telInput.s.dialCode + element.value;
            element.setAttribute('data-value', dialCode);
            element.setAttribute('value', dialCode);
        });

        Inputmask({
            autoUnmask: true,
            mask: mask.phone,
        }).mask(element);


        // Telefon formatlama 0 ve 9 engelleme
        const phoneFormatted = function (value) {
            value = value.replace(/^0/, "");
            value = value.replace(/^9/, "");

            return value;
        }

        // Telefon başındaki 0 rakamını engelleme
        element.addEventListener("input", function (event) {
            const value = event.target.value;

            const formattedValue = phoneFormatted(value);

            event.target.value = formattedValue;

        });

        // Telefon numara kontrolü
        element.addEventListener("keydown", function (event) {

            let invalid = event.target.closest('.phone-input')?.querySelector('.invalid-feedback');
            let valid = event.target.closest('.phone-input')?.querySelector('.valid-feedback');
            // console.log(invalid);
            // console.log(valid);

            const value = event.target.value;
            const formattedValue = phoneFormatted(value);

            // let dialCode = "+" + telInput.s.dialCode + element.value;
            // element.setAttribute('data-value', dialCode);
            // element.setAttribute('value', dialCode);

            if (!isValidPhoneNumber(formattedValue, 8, 10)) {

                if (valid && invalid) {
                    valid.style.display = 'none';
                    invalid.style.display = 'block';
                    invalid.innerText = 'Telefon numarası geçersiz veya eksik.';
                }

            } else {

                // valid.style.display = 'block';
                if (invalid) {

                    invalid.style.display = 'none';
                }

                // valid.innerText = 'Telefon numarası geçerli.';
                let dialCode = "+" + telInput.s.dialCode + element.value;
                element.setAttribute('data-value', dialCode);
                element.setAttribute('value', dialCode);
            }
        });
    })

    // Telefon mask
    let phoneMasks = document.querySelectorAll('*[mask-type="phone-mask"]');
    phoneMasks.forEach((element) => {
        Inputmask({
            mask: '+99 ' + mask.phone,
            autoUnmask: true
        }).mask(element);
    })

    // Tarih
    let dates = document.querySelectorAll('*[mask-type="date"]');
    dates.forEach((element) => {
        Inputmask({
            autoUnmask: true,
            mask: mask.date
        }).mask(element);
    })

    // Url format
    let urls = document.querySelectorAll('*[mask-type="url"]');
    if (urls) {
        urls.forEach((element) => {
            Inputmask("url").mask(element);
        })
    }
}
MaskLoad();

// Telefon kontrol
export function isValidPhoneNumber(phoneNumber, minLength, maxLength) {
    if (phoneNumber.length > minLength && phoneNumber.length < maxLength) {
        return false;
    }

    const numericPattern = /^[0-9]+$/;
    if (!numericPattern.test(phoneNumber)) {
        return false;
    }

    return true;
}

// Rastgele id oluşturma
export function GenerateUniqueId() {
    const timestamp = new Date().getTime();
    const random = Math.floor(Math.random() * 10000);
    return `${timestamp}-${random}`;
}

// Vergi hesaplama
export function TaxCalculate(price, rate = null) {
    // Varsayılan oran tanımlanmamışsa, global oranı kullan
    if (rate === null) {
        rate = parseInt(getTaxRate);
    }

    let type = taxType;

    // Belirtilen tip geçerli değilse varsayılan tipi kullan
    if (!['Including', 'Normal', 'Stoppage', 'Constant'].includes(type)) {
        // console.warn('Geçersiz vergi tipi. Varsayılan tip kullanılıyor.');
        type = 'Normal';
    }

    // console.log(type);

    if (type === 'Including') {
        // KDV dahil fiyatı hesapla
        return (price * rate) / (100 + rate);
    } else if (type === 'Normal') {
        // Normal vergiyi hesapla
        return price * (rate / 100);
    } else if (type === 'Stoppage') {
        // Kesinti tipinde fiyatı hesapla
        return price / rate;
    } else if (type === 'Constant') {
        // Sabit tipinde fiyatı geri döndür
        return price;
    } else {
        // console.error('Beklenmeyen bir hata oluştu. 0 döndürülüyor.');
        return 0;
    }
}
